import React from 'react';

const COLORS = {
  background: '#070a0d',
  panel: '#0c1117',
  panelBorder: '#1a2533',
  primary: '#00d4ff',
  warning: '#ffaa00',
  text: '#e6f0ff',
  textDim: '#5a7090',
};

/**
 * Catches a render/lifecycle error thrown by its children and shows a
 * fallback instead of letting the crash propagate up and take down the rest
 * of the app. React error boundaries require a class component -- there is
 * no hooks equivalent (getDerivedStateFromError/componentDidCatch).
 *
 * `label` identifies the wrapped section in both the fallback UI and the
 * console log, so a crash report is traceable back to which boundary caught it.
 */
class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error(`[RouteErrorBoundary:${this.props.label}]`, error, info.componentStack);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          minHeight: '400px',
          padding: '40px',
          background: COLORS.background,
          color: COLORS.text,
          fontFamily: '"Share Tech Mono", monospace',
          textAlign: 'center',
        }}
      >
        <div
          style={{
            border: `1px solid ${COLORS.panelBorder}`,
            background: COLORS.panel,
            borderRadius: '8px',
            padding: '32px 40px',
            maxWidth: '480px',
          }}
        >
          <div style={{ fontSize: '32px', marginBottom: '16px' }}>⚠️</div>
          <div style={{ fontSize: '18px', color: COLORS.warning, marginBottom: '8px', letterSpacing: '1px' }}>
            {this.props.label} FAILED TO LOAD
          </div>
          <div style={{ fontSize: '13px', color: COLORS.textDim, marginBottom: '24px' }}>
            An unexpected error occurred in this section. The rest of the application is unaffected.
          </div>
          <button
            onClick={this.handleReload}
            style={{
              background: 'transparent',
              border: `1px solid ${COLORS.primary}`,
              color: COLORS.primary,
              padding: '10px 24px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontFamily: 'inherit',
              fontSize: '13px',
              letterSpacing: '1px',
            }}
          >
            RELOAD
          </button>
        </div>
      </div>
    );
  }
}

export default RouteErrorBoundary;
